// noinspection JSCheckFunctionSignatures

import router from '@/router';

/**
 * 路由跳转通用方法
 *
 * @param {String} url - 路由URL
 * @param {Object} params - 路由参数，可选，用于传递参数到目标路由。
 * @param {Object} options - 可选参数配置项
 * @param thenFunc {Function} 路由跳转成功后执行的方法
 * @param {Boolean} options.replace - 是否使用 replace 跳转（默认 false），
 *                                     如果为 true，则不会在历史记录中留下当前页面。
 * @param {String} options.query - URL 查询参数对象（可选），
 *                                   例如 { key: 'value' } 将在 URL 中以查询字符串的形式传递。
 *
 * @example
 * // 路由跳转示例
 * routerFunc('UserProfile', { userId: 123 }, { replace: true, query: { ref: 'header' } });
 */
function routerFunc(url, params = {}, options = {}, thenFunc = null) {

    // 构建路由对象
    const routeTemp = {
        path: url,
        params: params,
        query: options.query || {}
    };

    // 根据 options.replace 判断是 push 还是 replace
    if (options.replace) {
        router.replace(routeTemp).then(thenFunc);
    } else {
        router.push(routeTemp).then(thenFunc);
    }
}


export const wmsRouter = {
    product: {
        edit(product) {
            if (product == null) {
                window.localStorage.removeItem('product');
            } else {
                window.localStorage.setItem('product', JSON.stringify(product));
            }
            routerFunc('/product-edit');
        },
        list() {
            routerFunc('/product-admin');
        },

    },

    log: {
        list() {
            routerFunc('/sys-set/log');
        }
    },

    miu: {
        teacherService: {
            tagManage() {
                routerFunc("/miu/miu-teacher-service-tag-manage");
            },
        }
    }
}